import angular from "angular";
import { directiveFactory } from "../angular-core";

export class NgRightClickDirective implements ng.IDirective {
    static componentName: string = "ngRightClick";
    static $inject = ["$parse"];
    link = (scope: ng.IScope, element: JQLite, attrs: ng.IAttributes) => {
        const fn = this.$parse(attrs.ngRightClick);
        element.bind("contextmenu", function (event: $TSFixMe) {
            scope.$apply(function () {
                event.preventDefault();
                fn(scope, { $event: event });
            });
        });
    };
    constructor(protected $parse: ng.IParseService) {}
}

angular
    .module("topline.directives")
    .directive(NgRightClickDirective.componentName, directiveFactory(NgRightClickDirective));